import { render, staticRenderFns } from "./RelatedPersonTypeForm.vue?vue&type=template&id=3ae4bc33&"
import script from "./RelatedPersonTypeForm.vue?vue&type=script&lang=js&"
export * from "./RelatedPersonTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports